import { render, staticRenderFns } from "./EditBase.vue?vue&type=template&id=6644ce88&"
import script from "./EditBase.vue?vue&type=script&lang=ts&"
export * from "./EditBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports